import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_label_exts_RowClass, bl_fi_mst_label_hdr_RowClass } from '../../../dbschema';

export class LabelContainerModel extends BaseContainerModel {
  bl_fi_mst_label_hdr: bl_fi_mst_label_hdr_RowClass = new bl_fi_mst_label_hdr_RowClass();
  bl_fi_mst_label_exts: bl_fi_mst_label_exts_RowClass[] = [];
}

